/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `exact` - exact
 * * `iexact` - iexact
 * * `contains` - contains
 * * `icontains` - icontains
 * * `in` - in
 * * `gt` - gt
 * * `gte` - gte
 * * `lt` - lt
 * * `lte` - lte
 * * `startswith` - startswith
 * * `istartswith` - istartswith
 * * `endswith` - endswith
 * * `iendswith` - iendswith
 * * `range` - range
 * * `date` - date
 * * `year` - year
 * * `iso_year` - iso_year
 * * `month` - month
 * * `day` - day
 * * `week` - week
 * * `week_day` - week_day
 * * `iso_week_day` - iso_week_day
 * * `quarter` - quarter
 * * `time` - time
 * * `hour` - hour
 * * `minute` - minute
 * * `second` - second
 * * `isnull` - isnull
 * * `regex` - regex
 * * `iregex` - iregex
 */
export enum OperatorEnum {
    EXACT = 'exact',
    IEXACT = 'iexact',
    CONTAINS = 'contains',
    ICONTAINS = 'icontains',
    IN = 'in',
    GT = 'gt',
    GTE = 'gte',
    LT = 'lt',
    LTE = 'lte',
    STARTSWITH = 'startswith',
    ISTARTSWITH = 'istartswith',
    ENDSWITH = 'endswith',
    IENDSWITH = 'iendswith',
    RANGE = 'range',
    DATE = 'date',
    YEAR = 'year',
    ISO_YEAR = 'iso_year',
    MONTH = 'month',
    DAY = 'day',
    WEEK = 'week',
    WEEK_DAY = 'week_day',
    ISO_WEEK_DAY = 'iso_week_day',
    QUARTER = 'quarter',
    TIME = 'time',
    HOUR = 'hour',
    MINUTE = 'minute',
    SECOND = 'second',
    ISNULL = 'isnull',
    REGEX = 'regex',
    IREGEX = 'iregex',
}
